import { TimePeriodData } from '@shared/schema';

export const toUtcDateValue = (dateString: string) => {
  const date = new Date(dateString);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

export const getCurrentUtcDateValue = (now = new Date()) =>
  Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());

export const hasActivePeriod = (
  periods: TimePeriodData[],
  names: string[],
  currentUtcDateValue = getCurrentUtcDateValue(),
) =>
  periods.some(
    (period) =>
      names.includes(period.Name) &&
      currentUtcDateValue >= toUtcDateValue(period.StartDate) &&
      currentUtcDateValue <= toUtcDateValue(period.EndDate),
  );
